<template>
    <div class="button" :style="style" @mouseout="removeActive()" @mouseover="addActive()">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
    },
    data: function () {
        return {
            style: "",
        }
    },
    methods: {
        addActive: function () {
            this.style = "animation: itemSet 0.1s linear 0s 1 forwards;"
        },
        removeActive: function () {
            this.style = "animation: itemUnSet 0.1s linear 0s 1 forwards;"
        },
    }
}
</script>

<style>
.button {
    display: inline-block;
    color: seashell;
    fill: seashell;
    border-style: solid;
    border-color: seashell;
    border-width: 2px;
    padding: 2px 4px;
    text-align: center;
}
@keyframes itemSet {
    100% {
        background-color: seashell;
        border-color: #ff8454;
        color: #ff8454;
        fill: #ff8454;
    }
}

@keyframes itemUnSet {
    0% {
        background-color: seashell;
        color: #ff8454;
        fill: #ff8454;
    }
    100% {
        color: seashell;
        border-color: seashell;
        fill: seashell;
    }
}
</style>